module.exports = __webpack_public_path__ + "img/openspace_help.f192f086.png";